import { z } from 'zod'
import { ConfirmTwoFactorRequestSchema } from '~/services/api/generated'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

// A key absent from the raw input stays absent -- introducing it (even as null/undefined)
// would add a wire key callers never sent, breaking exact-body assertions downstream.
const normalize = fieldNormalizer({ blankToNull: ['code', 'recovery_code'] })

// ConfirmTwoFactorRequest::withValidator: a code or a recovery code is required.
export const UserConfirmTwoFactor = (_context: NoContext) =>
  z.preprocess(normalize, ConfirmTwoFactorRequestSchema).superRefine((value, issues) => {
    const credentialMissing = value.code == null && value.recovery_code == null
    if (credentialMissing) {
      issues.addIssue({ code: 'custom', message: 'code_required', path: ['code'] })
    }
  })
